import { Outlet } from 'react-router-dom';

/**
 * Route outlet for the app shell. Global chrome (left nav, AppChromeHeader
 * utilities) lives outside this tree and never remounts.
 *
 * We intentionally do not opacity-fade the whole page (that made the header
 * flicker). We also do not freeze/remount by pathname — that was only needed
 * for AnimatePresence exit animations (RUT-2642) and made navigations feel
 * like full page reloads once the fade was removed.
 */
export function AnimatedOutlet() {
  return (
    <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
      <Outlet />
    </div>
  );
}
